module.exports = __webpack_public_path__ + "img/x1.d5938c6c.jpg";